import { createContext } from 'react';

/**
 * Set to true by PrimaryNavFixedItem while the item is animating out.
 * NavItem reads this to wrap its SidebarMenuButton in a height-collapse
 * motion div (inside the <li>, so the DOM stays valid).
 */
export const NavItemCollapsingContext = createContext(false);
